import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { CKEditorComponent } from 'ng2-ckeditor';

import { AngularFileUploadComponent } from '../file-upload/file-upload.component';

@Component({
    moduleId: module.id,
    selector: 'angular-mail-composer',
    templateUrl: 'angular-mail-composer.html',
    styleUrls: ['angular-mail-composer.css']
})
export class AngularMailComposerComponent {
    public mailFrom: string = null;
    public mailTo: string = null;
    public mailCc: string = null;
    public mailCcn: string = null;
    
    public mailObject: string = null;
    public mailBody: string = null;
    public allegati_default: string[] = new Array<string>();
    public isFromDisabled: boolean = true;

    //CKEDITOR;

    @ViewChild("fileUpload") fileUpload: AngularFileUploadComponent;
    @ViewChild("CKEditor") CKEditor: CKEditorComponent;

    @Input() urlUploadAllegati: string = null;
    @Input() operazioneAllegati: string;
    @Input() styleSheets: Array<string> = null;
    @Input() allowAllegati: boolean = true;
    @Input() isCCDisabled: boolean = false;
    @Input() config: any = {
        toolbar: [
            { name: 'undo', items: ['Undo', 'Redo'] },
            { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', '-', 'CopyFormatting', 'RemoveFormat'] },
            { name: 'paragraph', items: ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'] },
            { name: 'colors', items: ['TextColor', 'BGColor'] },
            { name: 'styles', items: ['Font', 'FontSize'] },
            { name: 'insert', items: ['Image', 'Table', 'HorizontalRule', 'SpecialChar'] },
            { name: 'document', items: ['Source'] }
        ],
        height: '350px',
        bodyClass: 'mail-editor-body',
        allowedContent: true,
        extraAllowedContent: 'a a[href]',
        contentsCss: ['https://cdn.ckeditor.com/4.5.11/full/contents.css?t=G87E']
    }

    @Output() composerChange = new EventEmitter();
    @Output() composerReady = new EventEmitter();
    @Output() composerFocus = new EventEmitter();
    @Output() composerBlur = new EventEmitter();
    @Output() onFileUploadError = new EventEmitter();

    reset() {
        this.mailFrom = "";
        this.mailTo = "";
        this.mailCc = "";
        this.mailCcn = "";
        this.mailObject = "";
        this.mailBody = "";
        this.fileUpload.reset();
    }

    compileConfig() {
        this.CKEditor.ngOnDestroy = this.onCKEditorDestroy.bind(this);
        let c = this.config;
        if (this.styleSheets) {
            if (!c.contentsCss) c.contentsCss = [];
            for (let i = 0; i < this.styleSheets.length; i++) c.contentsCss.push(this.styleSheets[i]);
        }
        return c;
    }

    onCKEditorDestroy() {
        var _this = this.CKEditor;
        if (_this.instance) {
            setTimeout(function () {
                let warn = console.warn;
                console.warn = function() {};

                _this.instance.removeAllListeners();
                this.CKEDITOR.instances[_this.instance.name].destroy(); 
                _this.instance.destroy(); 
                _this.instance = null;
                
                console.warn = warn;
            });
        }
    }

    onComposerChange() {
        this.composerChange.emit(this);
    }

    onComposerReady() {
        this.composerReady.emit(this);
    }

    onComposerFocus() {
        this.composerFocus.emit(this);
    }

    onComposerBlur() {
        this.composerBlur.emit(this);
    }

    errorFileUpload(errorMessage: string) {
        this.onFileUploadError.emit(errorMessage);
    }

    getAllegati(): Array<string> {
        return this.fileUpload.getFiles();
    }

    removeAllegatoDefault(file: string) {
        let i = this.allegati_default.indexOf(file);
        if (i > -1) this.allegati_default.splice(i, 1);
    }
}


// WEBPACK FOOTER //
// ./src/angular_library/components/mail-composer/angular-mail-composer.component.ts